import { IRefreshTokenRequest } from '../dtos/requests/refresh.request';
import { IToken } from '../dtos/responses/token.response';

export class Token implements IToken {
    tokenType: string;
    isPersisted: boolean;
    accessToken: string;
    accessTokenExpiresAt: Date;
    refreshToken: string;
    refreshTokenExpiresAt: Date;

    private constructor(token: IToken) {
        this.tokenType = token.tokenType;
        this.isPersisted = token.isPersisted;
        this.accessToken = token.accessToken;
        this.accessTokenExpiresAt = new Date(token.accessTokenExpiresAt);
        this.refreshToken = token.refreshToken;
        this.refreshTokenExpiresAt = new Date(token.refreshTokenExpiresAt);
    }

    toRefreshTokenRequest(): IRefreshTokenRequest {
        return {
            refreshToken: this.refreshToken
        };
    }

    static create(token: IToken): Token {
        return new Token(token);
    }

    isExpired(): boolean {
        return this.isAccessTokenExpired() && this.isRefreshTokenExpired();
    }

    isAccessTokenExpired(): boolean {
        const now = new Date();
        return this.accessTokenExpiresAt <= now;
    }

    isRefreshTokenExpired(): boolean {
        const now = new Date();
        return this.refreshTokenExpiresAt <= now;
    }
}
